// ============================================================
// SAC - Page "RDV à planifier" (workflow=nouvelle)
// ------------------------------------------------------------
// Toutes les commandes creees par les agents de ventes qui
// attendent d'etre planifiees par un agent logistique.
// Etape 1 sur 3 de la chaine Service Client.
// ============================================================
import React from 'react';
import { Inbox, CalendarCheck2, Users, Route } from 'lucide-react';
import SacGridView from '../components/SacGridView';

const SAC_TABS = [
  { href: '/admin/service-client/a-planifier', label: 'RDV à planifier', icon: Inbox, active: true },
  { href: '/admin/route-optimisation',         label: 'Route Optimisation', icon: Route, active: false },
  { href: '/admin/service-client/planifies',   label: 'RDV planifiés',   icon: CalendarCheck2, active: false },
  { href: '/admin/service-client/attribuees',  label: 'Attribuées au répartiteur', icon: Users, active: false },
];

const SacAPlanifierPage = () => (
  <SacGridView
    title="RDV À PLANIFIER"
    subtitle="Nouvelles commandes en attente de planification par un agent logistique"
    iconLetters="SC"
    iconColor="cyan"
    workflowIn={['nouvelle']}
    assignmentType="logistique"
    allowShortcuts
    showReturnsAlarm
    nextWorkflow="rdv_planifie"
    nextWorkflowLabel="Planifier & attribuer"
    scopeMine={false}
    subTabs={SAC_TABS}
    storageKey="sacGrid.aPlanifier"
  />
);

export default SacAPlanifierPage;
